import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Tag({ className, variant = "informational", size = "normal", ...rest }) {
    return (_jsx("span", { className: classNames("cvr-tag", className, {
            "cvr-tag--basic": variant === "basic",
            "cvr-tag--informational": variant?.startsWith("informational"),
            "cvr-tag--promoted": variant?.startsWith("promoted"),
            "cvr-tag--highlighted": variant?.endsWith("highlighted"),
            "cvr-tag--small": size === "small",
            "cvr-tag--normal": size === "normal",
        }), ...rest }));
}
